<template>
  <!-- 註冊頁 -->
  <app-logo-page-container>
    <v-flex xs10 sm6 md7>
      <v-form
        ref="form"
        v-model="valid">

        <transition name="fade" mode="out-in" type="transition">
          <v-layout v-if="!signupSuccess" row wrap>
            <v-flex xs12 md5>
              <v-text-field
                class="field"
                v-model="username"
                autocomplete="username"
                :rules="usernameRules"
                :hint="usernameHint"
                counter="16"
                prepend-icon="person"
                label="使用者帳號"
                color="black"
                validate-on-blur />

              <v-text-field
                class="field"
                v-model="pwd"
                autocomplete="new-password"
                :rules="pwdRules"
                :type="showPwd ? 'text' : 'password'"
                :append-icon="showPwd ? 'visibility_off' : 'visibility'"
                counter="16"
                @click:append="showPwd = !showPwd"
                prepend-icon="lock"
                label="使用者密碼"
                color="black"
                validate-on-blur />

              <v-text-field
                class="field"
                v-model="confirmPwd"
                autocomplete="new-password"
                :rules="confirmPwdRules"
                :type="showConfirmPwd ? 'text' : 'password'"
                :append-icon="showConfirmPwd ? 'visibility_off' : 'visibility'"
                counter="16"
                @click:append="showConfirmPwd = !showConfirmPwd"
                prepend-icon="lock"
                label="再次輸入使用者密碼"
                color="black"
                validate-on-blur />

              <v-text-field
                class="field"
                v-model="email"
                prepend-icon="email"
                label="電子郵件"
                color="black"
                :rules="emailRules"
                validate-on-blur/>
            </v-flex>

            <!-- =============================== -->

            <v-flex xs12 md5 offset-md2>
              <v-text-field
                class="field"
                v-model="nickname"
                :rules="nicknameRules"
                prepend-icon="face"
                label="學生姓名"
                color="black"
                validate-on-blur/>

              <v-select
                class="field"
                v-model="gender"
                :items="genderOptions"
                :rules="genderRules"
                prepend-icon="wc"
                label="性別"
                color="black"
                no-data-text=''>
              </v-select>

              <v-select
                class="field"
                v-model="grade"
                :items="gradeOptions"
                :rules="gradeRules"
                prepend-icon="school"
                label="年級"
                color="black"
                no-data-text=''>
              </v-select>

              <v-text-field
                class="field"
                v-model="mobile4parent"
                :rules="mobile4parentRules"
                prepend-icon="phone"
                label="行動電話(家長)"
                color="black"
                validate-on-blur />
            </v-flex>
          </v-layout>
        </transition>

        <v-layout class="mt-4">
          <v-flex xs12 sm12 md6 offset-md3>
            <v-btn
              v-if="!signupSuccess"
              color="primary"
              :loading="loading"
              @click="submit"
              block>
              註冊
            </v-btn>

            <v-alert
              class="mt-4"
              v-show="errMsg"
              transition="slide-y-transition"
              :value="true"
              type="error">
              {{errMsg}}
            </v-alert>

            <v-alert
              class="mt-4"
              v-if="signupSuccess"
              transition="slide-y-transition"
              :value="true"
              icon="check_circle"
              outline
              type="info">
              註冊成功!
            </v-alert>

            <v-btn
              class="mt-4"
              flat
              block
              @click="$router.push({name: 'Signin'})">
              <v-icon class="mr-2">arrow_back</v-icon>
              返回登入頁
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
  </app-logo-page-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {
  signupUsername,
  signupPwd,
  signupConfirmPwd,
  signupEmail,
  signupNickname,
  signupGender,
  signupGrade,
  signupMobile4parent
} from '@/validate-rules';

export default {
  data() {
    return {
      valid: true,
      loading: false,
      errMsg: null,
      showPwd: false,
      showConfirmPwd: false,
      signupSuccess: false,

      username: '',
      usernameHint: signupUsername.hint,
      usernameRules: signupUsername.rules(),

      pwd: '',
      pwdRules: signupPwd.rules(),
      confirmPwd: null,
      confirmPwdRules: [...signupConfirmPwd.rules(), v => {
        return this.pwd === v || signupConfirmPwd.errMsg;
      }],

      email: '',
      emailRules: signupEmail.rules(),

      nickname: '',
      nicknameRules: signupNickname.rules(),

      gender: null,
      genderRules: signupGender.rules(),

      grade: null,
      gradeRules: signupGrade.rules(),

      mobile4parent: '',
      mobile4parentRules: signupMobile4parent.rules()
    };
  },

  computed: {
    ...mapGetters({
      genderOptions: 'genderOptions',
      gradeOptions: 'gradeOptions'
    })
  },

  methods: {
    ...mapActions(['signup']),

    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.errMsg = null;
      this.loading = true;
      try {
        await this.signup({
          username: this.username,
          pwd: this.pwd,
          email: this.email,
          confirmemail: this.email,
          nickname: this.nickname,
          gender: this.gender,
          grade: this.grade,
          mobile4parent: this.mobile4parent
        });
        this.signupSuccess = true;
      } catch (e) {
        this.errMsg = e.message;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.field {
  margin: 0;
  padding: 1.2rem 0 1.2rem 0;
}

</style>
